'use strict';

const measures = require('../util/measures');
const focusHelper = require('base/components/focus');
const attrHelpers = require('./components/attrHelpers');
const carouselConfig = require('../components/carousel-config');
const zoomImage = require('./zoom');
const afterpayWidget = require('./afterpayWidget');
const utils = require('../utils');
const pdpInstoreInventory = require('../product/pdpInstoreInventory');

// ID Selectors
const bopisMethodID = '#bopis-method';
const selectProductSizeModalID = '#selectProductSizeModal';
const chooseBonusProductModalID = '#chooseBonusProductModal';
const pdpCarouselID = '#pdpCarousel';
const productAttributesID = '#productAtributes';

// Class Selectors
const nonSellableMessageClass = '.non-sellable-msg';
const addToCartClass = '.add-to-cart';
const productQuickViewClass = '.product-quickview';
const productIdClass = '.product-id';
const productDetailClass = '.product-detail';
const notifyCartClass = '.notify-cart';
const dynamicAttrClass = '.dyanamic-attr';
const limitedQtyMsgClass = '.limited-qty-msg';
const storeNameClass = '.store-name';
const modalContentClass = '.modal-content';
const bonusProductItemClass = '.bonus-product-item';
const carouselInnerClass = '.carousel-inner';
const gridListClass = '.grid-list';
const quantitySelectClass = '.quantity-select';
const carouselIndicatorsClass = '.carousel-indicators';
const chooseBonusProductDialogClass = '.choose-bonus-product-dialog';
const dynamicProductAvailabilityClass = '.dyanamic-product-availability';
const productTileClass = '.product-tile';
const pgpGridsClass = '.pgp-grids';
const preCartProductsClass = '.pre-cart-products';
const modalBodyClass = '.modal-body';
const addToWishlistClass = '.add-to-wishlist';
const promotionsClass = '.promotions';
const addToCartMessagesClass = '.add-to-cart-messages';
const csrfClass = '.csrf-add-prod';
const bisnContainerClass = '.enable-bisn';
const bopisRadioButton = '#bopisMethodRadioButton';
const imageContainerImg = '.image-container img';
const miniCartSheetClass = '.mini-cart-sheet';

// Multi-class Selectors
const activeGridClasses = '.grid-list .gridview-active';
const sizeSelectedClasses = '.size-value.selected';
const outOfStockMessageClasses = '.non-input-label.out-of-stock-message';
const nonSellableMessageClasses = '.non-input-label.non-sellable-msg';
const selectedRefinementColorClasses = '.refinements.desktop .refinement-refinementcolor .selected-value';
const selectedBonusSummaryClasses = '.selected-bonus-products .bonus-summary';
// unavailable variation attributes (selectable = false) are marked by the unselectable class, but can still be selected
const selectedUnavailableAttributeClasses = '.selected .unselectable';

// Variables
const ARIA_HIDDEN = 'aria-hidden';
const BUTTON_SLIDES = 'button.sildes';
const PICTURE_PINCH_ZOOM = 'picture pinch-zoom';
const ALERT_DANGER = 'alert-danger';
const UPC_AVAILABLE = 'upc-available';
const UPC_UNAVAILABLE = 'upc-unavailable';
const DATA_CONTAINER_TYPE = 'data-containertype';
const IMAGE_CONTAINER_ANCHOR = '.image-container > a';
const ADD_TO_CART_SELECTOR = '.prices-add-to-cart-actions .add-to-cart';
const ADD_TO_CART_SPAN = '.add-to-cart span span';
const CAROUSEL_ITEM_CLASS = '.carousel-inner .carousel-item.zoom-image-js';
const SPINNER_REQUIRED_MODALS = ['#editWishlistProductModal', '#editProductModal', '#historyEditProductModal', selectProductSizeModalID];

/**
*  determines the display style from local storage
*/
function determineDisplayStyle() {
    const selectedViewStyle = localStorage.getItem('selectedViewStyle');
    if (selectedViewStyle === 'gridView') {
        $(activeGridClasses).click();
    } else if (selectedViewStyle === 'listView') {
        $('.grid-list .listview-inactive').click();
    } else {
        $(activeGridClasses).click();
    }
}

/**
 * Return the video object needed to create the carousel.
 * @param {Object} response - Response from the variation attributes API.
 * @return {Object} videoAsset to be used by create carousel.
 */
function getVideoObject(response) {
    const videoUrl = 'videoUrlFromImageGroup' in response.product && response.product.videoUrlFromImageGroup !== '' ? response.product.videoUrlFromImageGroup : response.product.videoUrl;
    const videoUrlPoster = 'videoPosterUrlFromImageGroup' in response.product && response.product.videoPosterUrlFromImageGroup !== '' ? response.product.videoPosterUrlFromImageGroup : response.product.videoPosterUrl;
    return {
        videoUrl: videoUrl,
        videoUrlPoster: videoUrlPoster
    };
}

/**
 * Retrieves the relevant pid value
 * @param {jquery} $el - DOM container for a given add to cart button
 * @return {string} - value to be used when adding product to cart
 */
function getPidValue($el) {
    const productSetClass = '.product-set';
    let pid;
    if ($(selectProductSizeModalID).hasClass('show') && !$(productSetClass).length) {
        pid = $(productQuickViewClass).data('pid');
    } else if ($('.product-quickview-modal ').length > 0 && !$('.product-quickview-modal ').hasClass('hidden') && !$(productSetClass).length) {
        pid = $(productQuickViewClass).data('pid');
    } else if ($('.product-set-detail').length || $(productSetClass).length) {
        pid = $($el).closest(productDetailClass).find(productIdClass).text();
    } else {
        pid = $('.product-detail:not(".bundle-item")').data('pid');
    }

    return pid;
}

/**
 * Retrieve contextual quantity selector
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {jquery} - quantity selector DOM container
 */
function getQuantitySelector($el) {
    return $el && $('.set-items').length
        ? $($el).closest(productDetailClass).find(quantitySelectClass)
        : $(quantitySelectClass);
}

/**
 * Retrieves the value associated with the Quantity pull-down menu
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {string} - value found in the quantity input
 */
function getQuantitySelected($el) {
    return getQuantitySelector($el).val();
}

/**
 * Updates the availability status in the Product Detail Page
 *
 * @param {Object} response - Ajax response object after an
 *                            attribute value has been [de]selected
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function updateAvailability(response, $productContainer) {
    let availabilityValue = '';
    const availabilityMessages = response.product.availability.messages;
    if (!response.product.readyToOrder && response.resources.info_selectforstock) {
        availabilityValue = '<li><div>' + response.resources.info_selectforstock + '</div></li>';
    } else {
        availabilityMessages.forEach(function (message) {
            availabilityValue += '<li><div>' + message + '</div></li>';
        });
    }
    const threshHoldMsg = response.product.availability.thresholdMsg;
    const count = response.product.availability.productsLeft;
    if (threshHoldMsg && count > 0) {
        availabilityValue = '<li><div>' + threshHoldMsg + ' ' + count + ' left. </div></li>';
    }

    $($productContainer).trigger('product:updateAvailability', {
        product: response.product,
        $productContainer: $productContainer,
        message: availabilityValue,
        resources: response.resources
    });
}

/**
 * Updates the notifyMeButton data attributes to be sent to backend.
 * @param {Object} data1 - data1
 */
function updateNotifyMeButtonAttributes(data1) {
    const notifyMeButton = $(notifyCartClass);
    if (notifyMeButton !== undefined && notifyMeButton.length && data1 !== undefined) {
        $(notifyMeButton).each(function (index, currentButton) {
            currentButton.setAttribute('data-pid', data1.id);
            currentButton.setAttribute('data-pname', data1.productName);
            currentButton.setAttribute('data-productavailbilitydate', data1.sellableFrom);
            currentButton.setAttribute('data-pimage', data1.images.productDetail[0].src);
        });
    }
}

/**
 * Generates html for product attributes section
 *
 * @param {array} attributes - list of attributes
 * @return {string} - Compiled HTML
 */
function getAttributesHtml(attributes) {
    if (!attributes) {
        return '';
    }

    let html = '';

    attributes.forEach(function (attributeGroup) {
        if (attributeGroup.ID === 'mainAttributes') {
            attributeGroup.attributes.forEach(function (attribute) {
                html += '<div class="attribute-values">' + attribute.label + ': '
                    + attribute.value + '</div>';
            });
        }
    });

    return html;
}

/**
 * Updates the volumental data
 *
 * @param {OptionSelectionResponse} product - Product with Volumental data
 * @param {jQuery} $productContainer - DOM element for current product
 */
function updateVolumental(product, $productContainer) {
    var $volumentalContainer = $productContainer.find('#pdp-volumental');
    if ($volumentalContainer.length) {
        var $volProdWidth = product.volumentalWidth;
        var $volRecommendedSize = $productContainer.find('.volumental-length-recommendation');
        var volLengthSizeDiff = $productContainer.find('.vol-length-size-diff');
        var volWidth = $volumentalContainer.find('.vol-width p');
        var volHeight = $volumentalContainer.find('.vol-height p');
        var volInstepHeight = $volumentalContainer.find('.vol-instep-height p');
        var volHeelWidth = $volumentalContainer.find('.vol-heel-width p');
        if ($volProdWidth) {
            volLengthSizeDiff.empty().append(product.volumentalLengthSizeDiff);
            volWidth.empty().append(product.volumentalWidth);
            volHeight.empty().append(product.volumentalArchHeight);
            volInstepHeight.empty().append(product.volumentalInstepHeight);
            volHeelWidth.empty().append(product.volumentalHeelWidth);
            $volRecommendedSize.removeClass('d-none');
            $volumentalContainer.removeClass('d-none');
        } else {
            $volRecommendedSize.addClass('d-none');
            $volumentalContainer.addClass('d-none');
        }
    }
}

/**
 * @typedef UpdatedOptionValue
 * @type Object
 * @property {string} id - Option value ID for look up
 * @property {string} url - Updated option value selection URL
 */

/**
 * @typedef OptionSelectionResponse
 * @type Object
 * @property {string} priceHtml - Updated price HTML code
 * @property {Object} options - Updated Options
 * @property {string} options.id - Option ID
 * @property {UpdatedOptionValue[]} options.values - Option values
 */

/**
 * Updates DOM using post-option selection Ajax response
 *
 * @param {OptionSelectionResponse} optionsHtml - Ajax response optionsHtml from selecting a product option
 * @param {jQuery} $productContainer - DOM element for current product
 */
function updateOptions(optionsHtml, $productContainer) {
    // Update options
    $productContainer.find('.product-options').empty().html(optionsHtml);
}

/**
 * Shows and hides the wishlist option
 * @param {Object} availability - Object containing product details
 */
function updateWishListIcon(availability) {
    var isAvailable = availability ? (availability.preOrder || availability.backorder) : false;
    var preorderEl = $('.wishlist-preorder');
    if (isAvailable) {
        if (!preorderEl.hasClass('hidden')) {
            preorderEl.addClass('hidden');
        }
    } else {
        preorderEl.removeClass('hidden');
    }
}

/**
 * Called to check if product images or product details is sticky
 */
function stickyProductDescription() {
    window.requestAnimationFrame(function () {
        var $productImgContainer = $('.pdpimg-container');
        var $productDetails = $('#productDetails');
        if ($(window).width() > 992) {
            var carouselHeight = $(pdpCarouselID).height();
            var productDetailsHeight = $productDetails.height();
            if (carouselHeight < productDetailsHeight) {
                $productImgContainer.css({
                    position: 'sticky',
                    top: $('#header').height()
                });
            }
        } else {
            $productDetails.css({ position: 'unset' });
            $productImgContainer.css({ position: 'unset' });
        }
    });
}

$('body').on('stickyHeaderUpdate', stickyProductDescription);

/**
 * Adds the model information to the PDP Gallery
 * Called from createCarousel
 * @param {Object} imgs - Array item of a product image, along with related information
 * @param {jQuery} carousel - the pdp carousel element
 * @param {Object} product - product object
 */
function addModelData(imgs, carousel, product) {
    var showModelSizeData = $(pdpCarouselID).data('showmodeldata');
    var label = $(pdpCarouselID).data('modeldatalabel') && $(pdpCarouselID).data('modeldatalabel').length ? $(pdpCarouselID).data('modeldatalabel') : 'Sizing';
    // Only add div container model data if it exists
    // Default Alt is New Balance {productname}, variationvalue
    if (showModelSizeData && (imgs.alt !== product.brand + ' ' + imgs.title)) {
        $('<div class="model-info-wrapper"><button type="button" class="model-info-btn" title="Model Info Button"><span class="model-btn-text display-color-name color-name-mobile font-body regular">' + label + '</span></button><div class="model-content d-none"><div class="content-btn-text"><span class="model-btn-text display-color-name color-name-mobile font-body regular">' + label + '</span><span class="model-close-btn"><svg role="img" aria-label="close icon" width="12" height="12" focusable="false"><use href="#close-icon" aria-hidden="true"></use></svg></span></div><div class="model-info"></div></div></div>').insertAfter($(carousel).find(CAROUSEL_ITEM_CLASS).last().find('picture'));
        // Add the model info
        $(carousel).find(CAROUSEL_ITEM_CLASS).last().find('.model-info')
            .append(imgs.alt);
    }
}

/**
 * Dynamically creates Bootstrap carousel from response containing images
 * @param {Object[]} imgs - Array of large product images,along with related information
 * @param {Object} $productContainer - DOM element for a given product
 * @param {Object} videoAsset - video assets
 * @param {Object} product - product object
 */
function createCarousel(imgs, $productContainer, videoAsset, product) {
    var carousel = $productContainer.find('.carousel');
    var isEditCartorWishlist = $productContainer.find('.carouseldk-true').length;
    var $selectSizeProductModal = $(selectProductSizeModalID);
    var $historyEditProductModal = $('#historyEditProductModal');
    var isSelectSizeProductModal = $selectSizeProductModal.length ? $selectSizeProductModal.hasClass('show') : false;
    var isHistoryEditProductModal = $historyEditProductModal.length ? $historyEditProductModal.hasClass('show') : false;
    var hasVideoAsset = !!videoAsset.videoUrl;
    $(carousel).carousel('dispose');
    var carouselId = $(carousel).attr('id');
    $(carousel).find(carouselInnerClass).empty();
    var sliderImageText = $(pdpCarouselID).attr('data-slide-index-text');

    if (!isEditCartorWishlist && !isSelectSizeProductModal && !isHistoryEditProductModal) {
        if (imgs.length === 1) {
            $(carousel).empty().append('<ol class="carousel-indicators" tabindex="0"></ol><div class="carousel-inner carousel-inner-base carousel-desktop d-flex" aria-label="carousel" role="listbox"></div><div class="carousel-inner carousel-inner-zoom carousel-desktop d-none" aria-label="carousel-inner" role="listbox"></div>');
        } else {
            // Does not have d-flex, does have mobile carousel controls for the main view
            $(carousel).empty().append('<ol class="carousel-indicators" tabindex="0"></ol><div class="carousel-inner carousel-inner-base carousel-desktop" role="listbox"></div><div class="carousel-inner carousel-inner-zoom carousel-desktop d-none" role="listbox"></div><div class="d-lg-none"><button class="carousel-control-prev" href="#pdpCarousel" type="button" data-label="prev" data-slide="prev"><span class="sr-only">Previous</span></button><button class="carousel-control-next" href="#pdpCarousel" type="button" data-label="next" data-slide="next"><span class="sr-only">Next</span></button></div>');
        }
        // PDP base page images
        for (var i = 0; i < imgs.length; i += 1) {
            // need anchor tag for ContentSquare tracking
            $('<div class="carousel-item zoom-image-js"><button aria-label="' + imgs[i].alt + '" data-target="#zoommodal" class = "p-0 w-100" data-modelinfo="' + imgs[i].alt + '" data-src="' + imgs[i].src + '" data-toggle="modal""><picture></picture></button></div>').appendTo($(carousel).find(carouselInnerClass).first());
            if (imgs[i].pictureSource.length > 0) {
                for (var j = 0; j < imgs[i].pictureSource.length; j += 1) {
                    // eslint-disable-next-line sonarjs/no-duplicate-string
                    $('<source media="' + imgs[i].pictureSource[j].media + '" type="' + imgs[i].pictureSource[j].type + '" data-srcset="' + imgs[i].pictureSource[j].srcset + '"></source>')
                        .appendTo($(carousel)
                            .find(CAROUSEL_ITEM_CLASS).last().find('picture'));
                }

                // eslint-disable-next-line sonarjs/no-duplicate-string
                $('<img src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" data-src="' + imgs[i].src + '" alt="' + imgs[i].alt + '" class="tile-image img-fluid zoom-in lazypreload lazyload" title="' + imgs[i].title + '" data-index=' + i + ' data-backdrop="false" />').appendTo($(carousel).find(CAROUSEL_ITEM_CLASS).last().find('picture'));

                addModelData(imgs[i], carousel, product);
            }
            var slideIndexText = sliderImageText + ' ' + (((hasVideoAsset && i > 1) ? i + 1 : i) + 1);
            // eslint-disable-next-line sonarjs/no-duplicate-string
            $('<li data-target="#pdpCarousel" data-slide-to="' + ((hasVideoAsset && i > 1) ? i + 1 : i) + '" ><button aria-label="' + slideIndexText + '"></button></li>').appendTo($(carousel).find(carouselIndicatorsClass));
            if (hasVideoAsset && i === 1) {
                $('<li data-target="#pdpCarousel" data-slide-to="' + (i + 1) + '" ><button aria-label="' + sliderImageText + ' ' + (i + 2) + '"></button></li>').appendTo($(carousel).find(carouselIndicatorsClass));
            }

            if (i === 1 && hasVideoAsset) {
                var carouselIem = $('<div class="carousel-item carousel-video"></div>');
                var videoContainer = $('<div class="nb-video__product nb-video__product-js"></div>');
                var videoElement = $('<video poster="' + videoAsset.videoUrlPoster + '" preload="none" loop playsinline muted data-isproductvideo="true"></div>');
                videoElement.append('<source src="' + videoAsset.videoUrl + '" type="video/mp4">');
                // var videoButton = $('<button class="nb-video__play-button"></button>');

                var $carouselContainer = $(pdpCarouselID);
                var $carousel = $carouselContainer.find(carouselIndicatorsClass);
                $($($carousel).find('li:nth-child(3)')).first().addClass('video');

                videoContainer.append(videoElement);
                // videoContainer.append(videoButton);

                videoElement.appendTo(videoContainer);
                // videoButton.appendTo(videoContainer);
                videoContainer.appendTo(carouselIem);

                carouselIem.appendTo($('#pdpCarousel > div:nth-child(2)'));
            }
        }

        // PDP zoom images
        for (var l = 0; l < imgs.length; l += 1) {
            $('<div class="carousel-item zoom-image-js"><a href="javascript:void(0);"><picture><pinch-zoom min-scale="1"></pinch-zoom></picture></a></div>').appendTo($(carousel).find(carouselInnerClass).last());
            if (imgs[l].zoomPictureSource.length > 0) {
                if ($(window).width() > 991) {
                    for (var m = 0; m < imgs[l].zoomPictureSource.length; m += 1) {
                        // eslint-disable-next-line sonarjs/no-duplicate-string
                        $('<source media="' + imgs[l].zoomPictureSource[m].media + '" type="' + imgs[l].zoomPictureSource[m].type + '" srcset="' + imgs[l].zoomPictureSource[m].srcset + '"></source>')
                            .appendTo($(carousel)
                                .find(CAROUSEL_ITEM_CLASS).last().find(PICTURE_PINCH_ZOOM));
                    }
                    $('<img src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" data-src="' + imgs[l].zoomsrc + '" srcset="' + imgs[l].srcset + '" data-index="' + l + '" alt="' + imgs[l].alt + '" class="tile-image img-fluid zoom-in lazyload lazypreload" data-toggle="modal" data-index=' + l + ' data-target="#zoommodal" data-backdrop="false"/>').appendTo($(carousel).find(CAROUSEL_ITEM_CLASS).last().find(PICTURE_PINCH_ZOOM));
                } else {
                    $('<img src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" data-src="' + imgs[l].zoomsrc + '" srcset="' + imgs[l].srcset + '" data-index="' + l + '" alt="' + imgs[l].alt + '" class="tile-image img-fluid zoom-in lazyload lazypreload" data-toggle="modal" data-index=' + l + ' data-target="#zoommodal" data-backdrop="false"/>').appendTo($(carousel).find(CAROUSEL_ITEM_CLASS).last().find(PICTURE_PINCH_ZOOM));
                    for (var n = 0; n < imgs[l].zoomPictureSource.length; n += 1) {
                        $('<source media="' + imgs[l].zoomPictureSource[n].media + '" type="' + imgs[l].zoomPictureSource[n].type + '" srcset="' + imgs[l].zoomPictureSource[n].srcset + '"></source>')
                            .appendTo($(carousel)
                                .find(CAROUSEL_ITEM_CLASS).last().find(PICTURE_PINCH_ZOOM));
                    }
                }
            }
        }
    } else {
        $(carousel).empty().append('<ol class="carousel-indicators" tabindex="0"></ol><div class="carousel-inner carousel-inner-base carousel-desktop" role="listbox"></div>');
        for (var k = 0; k < imgs.length; k += 1) {
            $('<div class="carousel-item col-12 p-1 caro-' + k + '"></div>').appendTo($(carousel).find(carouselInnerClass));
            $('<img src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" data-src="' + imgs[k].src + '" class="tile-image img-fluid lazypreload lazyload"/>').appendTo($(carousel).find(carouselInnerClass).last().find('.caro-' + k));
            $('<li data-target="#' + carouselId + '" data-slide-to="' + k + '" class=""><button aria-label= "' + sliderImageText + ' ' + k + '"></button></li>').appendTo($(carousel).find(carouselIndicatorsClass));
        }
        $(carousel).append('<a class="carousel-control-prev" href="#' + carouselId + '" role="button" data-label="prev" data-slide="prev">');
        $('<span class="sr-only">Previous</span>').appendTo($(carousel).find('.carousel-control-prev'));
        $(carousel).append('<a class="carousel-control-next" href="#' + carouselId + '" role="button" data-label="next" data-slide="next">');
        $('<span class="sr-only">Next</span>').appendTo($(carousel).find('.carousel-control-next'));
    }
    zoomImage.zoomModalCall();
    $($(carousel).find('.carousel-item')).first().addClass('active');
    $($(carousel).find('.carousel-indicators > li')).first().addClass('active');
    if (imgs.length === 1) {
        $($(carousel).find('.carousel-indicators, button[class^="carousel-control-"]')).detach();
    }

    $(carousel).carousel({ wrap: false });
    carouselConfig.togglePDPCarouselControls($(carousel));
    if (!isEditCartorWishlist && typeof window.instantiateProductVideos === 'function') {
        window.instantiateProductVideos();
    }

    stickyProductDescription();
    // update class name to indicate the # of images in the carousel for styling purposes
    // server-side function is maintained in uiHelpers - getUiControls for use in standardImageGallery.isml
    $(carousel).attr('class').split(' ').forEach(function (className) {
        if (className.startsWith('carousel-length-')) {
            let imageTotal = (hasVideoAsset) ? imgs.length + 1 : imgs.length;
            $(carousel).removeClass(className);
            $(carousel).addClass('carousel-length-' + imageTotal);
        }
    });
}

// play any current playing videos when changing slides
$('body').on('slide.bs.carousel', pdpCarouselID, function () {
    $('#pdpCarousel video').trigger('play');
});

// Toggle controls after slide is complete
$('body').on('slid.bs.carousel', pdpCarouselID, function () {
    carouselConfig.togglePDPCarouselControls($('#pdpCarousel'), '.carousel-inner-base');
});

$('body').on('slid.bs.carousel', '#zoom-modal', function () {
    carouselConfig.togglePDPCarouselControls($('#zoom-modal'), '.carousel-inner-zoom');
});

/**
 * toggle elements view when product is Out of stock or non sellable
 */
function hideProductAvailabilityElements() {
    $(ADD_TO_CART_SELECTOR).addClass('d-none');
    $(notifyCartClass).removeClass('d-none');
    $('.afterpay-pdp-wrapper').addClass('d-none');
    $(dynamicProductAvailabilityClass).addClass('d-none');
}

/**
 * toggle elements view when product is available
 */
function showProductAvailabilityElements() {
    $(ADD_TO_CART_SELECTOR).removeClass('d-none');
    $(notifyCartClass).addClass('d-none');
    $('.afterpay-pdp-wrapper').removeClass('d-none');
    $(dynamicProductAvailabilityClass).removeClass('d-none');
}

/**
 * Toggle Variations view and availability message.
 */
function toggleAvailabilityMessage() {
    var $dynamicAttr = $(dynamicAttrClass);
    var $outOfStockMessage = $('.out-of-stock-message');
    var $noneSellableMessage = $(nonSellableMessageClass);
    var $productAvailability = $('.product-availability');
    if ($dynamicAttr.length) {
        $dynamicAttr.removeClass('d-none');
    }

    if ($outOfStockMessage.length) {
        $outOfStockMessage.addClass('d-none');
    }

    if ($noneSellableMessage.length) {
        $noneSellableMessage.addClass('d-none');
    }

    if ($productAvailability.length) {
        $productAvailability.removeClass('d-none');
    }
}

/**
 * Toggle store select button
 * @param {Object} response - response object
 */
function toggleSelectStoreButton(response) {
    if (window.sitePrefs.bopisEnabled) {
        var selectStoreBtn = $('.btn-get-in-store-inventory');
        if (response.product.readyToOrder && response.product.available && response.product.availableForInStorePickup) {
            selectStoreBtn.removeAttr('disabled');
        } else {
            selectStoreBtn.attr('disabled', 'disabled');
        }
    }
}

/**
 * Update Product details
 * @param {string} availableDate 09/01/2020
 * @param {string} availableTime 09:00 am
 */
function updateNonSellableMessage(availableDate, availableTime) {
    var $nonSellableMessage = $(nonSellableMessageClass);
    if ($nonSellableMessage.length) {
        $nonSellableMessage.removeClass('d-none');
        var $date = $nonSellableMessage.find('.date');
        var $time = $nonSellableMessage.find('.time');

        if ($date.length && availableDate) {
            $date.html(availableDate);
        }

        if ($time.length && availableTime) {
            $time.html(availableTime);
        }
    }
}

/**
 * Method to reset the unisex fit conversion head and body elements
 */
function resetUnisexFitConversion() {
    var $unisexSizes = $("div[class*='js-unisex-size-']");
    if ($unisexSizes && $unisexSizes.length) {
        $unisexSizes.removeClass('d-none').addClass('d-none');
    }

    var $unisexHead = $('.unisex-fit-conversion-head');
    if ($unisexHead && $unisexHead.length && !$unisexHead.hasClass('d-none')) {
        $unisexHead.addClass('d-none');
    }

    var $unisexBody = $('.unisex-fit-conversion-body');
    if ($unisexBody && $unisexBody.length && $unisexBody.hasClass('d-none')) {
        $unisexHead.removeClass('d-none');
    }
}
/**
 * Method to check if the pdp if of the unisex product
 * @returns {boolean} true if unisex-fit-conversion div is present
 */
function isUnisexProduct() {
    var $isUnisexProduct = $('.unisex-fit-conversion');
    return ($isUnisexProduct && $isUnisexProduct.length);
}
/**
 * Method to toggle the unisex fit conversion div elements
 * @param {Object} $sizeElement current size element
 */
function toggleUnisexFitConversion($sizeElement) {
    resetUnisexFitConversion();
    var sizeValue = $sizeElement.attr('title') || $sizeElement.data('attrValue');
    if (sizeValue) {
        var $unisexDiv = $('.js-unisex-size-' + sizeValue);
        if ($unisexDiv && $unisexDiv.length) {
            $unisexDiv.removeClass('d-none');
            var $unisexBlock = $("div[class*='unisex-fit-conversion-']");
            if ($unisexBlock && $unisexBlock.length) {
                $unisexBlock.removeClass('d-none');
            }
        }
    }
}
/**
 * Method to display selectable variant
 */
function displaySelectableVariant() {
    var $variants = $('button.variation-attribute.unisex-size.nb-button.selectable');
    if ($variants && $variants.length) {
        toggleUnisexFitConversion($variants.first());
    } else {
        resetUnisexFitConversion();
    }
}

/**
 * Method to display fit conversion
 */
function displayFitConversion() {
    var $unisexFitConversion = $('.unisex-fit-conversion');
    if ($unisexFitConversion && $unisexFitConversion.length) {
        var $selectedVariant = $('button.variation-attribute.unisex-size.nb-button.selected.selectable');
        if ($selectedVariant && !$selectedVariant.length) {
            displaySelectableVariant();
        } else {
            toggleUnisexFitConversion($selectedVariant);
        }
    }
}
/**
 * Method to get price selector
 * @param {Object} $productContainer placeholder for productContainer
 * @return {Object} price selector object
 */
function getPriceSelector($productContainer) {
    var $priceSelector = $('.quick-view .price', $productContainer);
    if (!$priceSelector.length) {
        var $tempSelector = $('.prices .price', $productContainer);
        $priceSelector = ($tempSelector.length) ? $tempSelector : $('.prices .price');
    }
    return $priceSelector;
}
/**
 * Parses JSON from Ajax call made whenever an attribute value is [de]selected
 * @param {Object} response - response from Ajax call
 * @param {Object} response.product - Product object
 * @param {string} response.product.id - Product ID
 * @param {Object[]} response.product.variationAttributes - Product attributes
 * @param {Object[]} response.product.images - Product images
 * @param {boolean} response.product.hasRequiredAttrsSelected - Flag as to whether all required
 *     attributes have been selected.  Used partially to
 *     determine whether the Add to Cart button can be enabled
 * @param {jQuery} $productContainer - DOM element for a given product.
 */
function handleVariantResponse(response, $productContainer) {
    var isChoiceOfBonusProducts = $productContainer.parents(chooseBonusProductDialogClass).length > 0;
    var isVariant;
    if (response.product.variationAttributes) {
        attrHelpers.updateAttrs(response.product.variationAttributes, $productContainer, response.resources);
        isVariant = response.product.productType === 'variant';
        if (isChoiceOfBonusProducts && isVariant) {
            $productContainer.parent(bonusProductItemClass)
                .data('pid', response.product.id);

            $productContainer.parent(bonusProductItemClass)
                .data('ready-to-order', response.product.readyToOrder);
        }
        var sizeAttributes = response.product.variationAttributes.filter(function (arr) {
            return arr.id === 'size';
        });
        // Handle showing unisex size details via toggle fn
        if (sizeAttributes.length > 0 && isUnisexProduct()) {
            displayFitConversion();
        }
    }

    // Update primary images
    var primaryImageUrls = response.product.images.productDetail;

    createCarousel(primaryImageUrls, $productContainer, getVideoObject(response), response.product);

    updateWishListIcon(response.product.availability);
    // Update pricing
    if (!isChoiceOfBonusProducts) {
        var $priceSelector = getPriceSelector($productContainer);
        $priceSelector.replaceWith(response.product.price.html);
        var $stickyCart = $('.add-to-cart-sticky');
        if ($stickyCart !== undefined && response.product.price.sales !== undefined) {
            if ($stickyCart.find(ADD_TO_CART_SPAN) !== undefined) {
                $stickyCart.find(ADD_TO_CART_SPAN).text(response.product.price.sales.formatted);
                $stickyCart.find(ADD_TO_CART_SPAN).attr('content', response.product.price.sales.decimalPrice);
            } else if ($stickyCart.find('.add-to-cart span') !== undefined) {
                $stickyCart.find('.add-to-cart span').text(response.product.price.sales.formatted);
            }
        }
    }

    document.body.dispatchEvent(new CustomEvent('product:updatePromotions'));

    updateAvailability(response, $productContainer);

    var modelSizingInfo = response.product.modelSizingInformation;
    if (modelSizingInfo && modelSizingInfo.length > 0) {
        var $modelInfoContainer = $productContainer.find('.model-sizing-info');
        var $modelList = $modelInfoContainer.empty().append('<ul class="m-3"></ul>').find('ul');
        for (var i = 0; i < modelSizingInfo.length; i += 1) {
            $modelList.append('<li>' + modelSizingInfo[i] + '</li>');
        }
    } else {
        $productContainer.find('.model-sizing-info').empty();
    }

    // Refresh wishlist changes
    var wishlistUrl = $('.wishlist-url').text();

    if (wishlistUrl && !$productContainer.hasClass('product-quickview')) {
        $.ajax({
            url: wishlistUrl,
            type: 'get',
            dataType: 'json',
            data: {
                pid: response.product.id,
                jsonResponse: true
            },
            success: function (data) {
                if (data.itemExistsFlag) {
                    $(addToWishlistClass).addClass('d-none');
                    $('.added-to-wishlist').removeClass('d-none');
                } else {
                    $('.added-to-wishlist').addClass('d-none');
                    $(addToWishlistClass).removeClass('d-none');
                }
            },
            error: function () {
            }
        });
    }

    if ($('.edit-wl-product-id').length) {
        $('.edit-wl-product-id').text(response.product.id);
    }

    if (isChoiceOfBonusProducts) {
        var $selectButton = $productContainer.find('.select-bonus-product');
        $selectButton.trigger('bonusproduct:updateSelectButton', {
            product: response.product, $productContainer: $productContainer
        });
    } else {
        // Enable "Add to Cart" button if all required attributes have been selected
        $('button.add-to-cart, button.add-to-cart-global, button.update-cart-product-global').trigger('product:updateAddToCart', {
            product: response.product, $productContainer: $productContainer
        }).trigger('product:statusUpdate', response.product);

        // Refresh Afterpay Widget
        if (response.product.price.sales && response.product.price.sales.value) {
            afterpayWidget.getWidget(response.product.id, response.product.price.sales.value, 'pdp-afterpay-message', $productContainer);
        }
    }

    if (response.qtyLimit && response.qtyLimit.limit) {
        $productContainer.find(limitedQtyMsgClass).removeClass('d-none');
        $productContainer.find(addToCartClass).prop('disabled', true);
    } else {
        $productContainer.find(limitedQtyMsgClass).addClass('d-none');
    }

    // Update attributes
    if (response.product.attributes) {
        $productContainer.find('.main-attributes').empty()
            .html(getAttributesHtml(response.product.attributes));
    }

    toggleSelectStoreButton(response);
}

/**
 * @typespec UpdatedQuantity
 * @type Object
 * @property {boolean} selected - Whether the quantity has been selected
 * @property {string} value - The number of products to purchase
 * @property {string} url - Compiled URL that specifies variation attributes, product ID, options,
 *     etc.
 */

/**
 * Updates the quantity DOM elements post Ajax call
 * @param {UpdatedQuantity[]} quantities -
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function updateQuantities(quantities, $productContainer) {
    if ($productContainer.parent(bonusProductItemClass).length <= 0) {
        var optionsHtml = quantities.map(function (quantity) {
            var selected = quantity.selected ? ' selected ' : '';
            return '<option value="' + quantity.value + '"  data-url="' + quantity.url + '"'
                + selected + '>' + quantity.value + '</option>';
        }).join('');
        getQuantitySelector($productContainer).empty().html(optionsHtml);
    }
}

/**
 * Updates the sticky element image post Ajax call
 * @param {ProductImages[]} productImages -
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function updateStickyImage(productImages, $productContainer) {
    var imgToUpdate = productImages && productImages.productDetail && productImages.productDetail.length && productImages.productDetail[0].src;
    if (imgToUpdate) {
        $productContainer.find('.add-to-cart-sticky .sticky-img img').attr({
            src: imgToUpdate,
            alt: productImages.productDetail[0].alt
        });
    }
}

/**
 * Update BOPIS display on PDP
 * @param {Object} pickUpInStore - data object with bopis information
 * @param {Object} product - data object with product information
 * @param {jQuery} $productContainer - DOM container for a given product
 * @param {string} storeInventoryMessageTemplate - template for product store inventory message
 */
function updateBopis(pickUpInStore, product, $productContainer, storeInventoryMessageTemplate) {
    const inStores = pickUpInStore && pickUpInStore.storesModel && pickUpInStore.storesModel.stores.length > 0;
    const bopisEligible = pickUpInStore && pickUpInStore.bopisEligible;
    let storePlaceholder;

    $('.change-store').each(function () {
        $(this).data('validate-ats', bopisEligible);
        $(this).data('pid', product.id);
    });

    $('.btn-storelocator-search').each(function () {
        $(this).data('search-ats', bopisEligible);
        $(this).data('search-pid', product.id);
    });

    let isSizeSelected = document.querySelector(sizeSelectedClasses);
    let storeAts = 0;

    if (bopisEligible) {
        let storePlaceholderID;
        $productContainer.find(bopisMethodID).removeClass('disable');
        storePlaceholderID = $productContainer.find(storeNameClass).data('store-placeholder');
        $productContainer.find(storeNameClass).removeAttr('data-placeholder').attr({ 'data-store-id': storePlaceholderID });

        if (inStores) {
            const currentStore = pickUpInStore.storesModel.stores[0];
            storeAts = currentStore.storeATS;
            $('.store-map-link').html(currentStore.storeNavigationHtml);
        }

        // If it is a bra, we should also check for a cup value
        if (document.querySelectorAll('.cup-value').length) {
            const isCupSelected = document.querySelector('.cup-value.selected');
            isSizeSelected = isSizeSelected && isCupSelected;
        }

        pdpInstoreInventory.updatePISMessage(isSizeSelected, inStores, storeAts, storeInventoryMessageTemplate);
        pdpInstoreInventory.showPickupStoreRadio();
    } else {
        // disable ship to store for selected variant
        $productContainer.find(bopisMethodID).addClass('disable');
        storePlaceholder = $productContainer.find(storeNameClass).data('store-id');
        $productContainer.find(storeNameClass).removeAttr('data-store-id').attr({ 'data-store-placeholder': storePlaceholder });
        $('.change-store').removeAttr('data-validate-ats').attr({ 'data-validate-ats': 'false' });
        // CHO-636 allows for sizes not always online (thus !bopisEligible) to be selected on the PDP for BOPIS fulfillment
        // so we want to update the store inventory message regardless of bopisEligible
        pdpInstoreInventory.updatePISMessage(isSizeSelected, inStores, storeAts, storeInventoryMessageTemplate);
    }
}

const Bopis = (function () {
    let lastArguments = null;
    const loaderSelector = '.pdp-in-store-inventory-loader';

    const updateWithLastArguments = function () {
        if (lastArguments) {
            updateBopis(...lastArguments);
        }
    };
    document.addEventListener('bopis:pdpBlockLoaded', updateWithLastArguments);

    return {
        update(...args) {
            const loader = document.querySelector(loaderSelector);

            if (loader) {
                lastArguments = args;
            } else {
                updateBopis(...args);
            }
        }
    };
}());

/**
 * starts or stops the spinner based on condition
 * @param {array} nbModals - selector for all product edit modal's
 * @param {boolean} startspinner - whether the spinner should start or stop
 */
function SpinnerOnModal(nbModals, startspinner) {
    if (!nbModals.length) {
        return;
    }

    nbModals.forEach(function (modalId) {
        if ($(modalId).hasClass('show') && startspinner) {
            $(modalId).find(modalBodyClass).spinner().start();
        } else {
            $(modalId).find(modalBodyClass).spinner().stop();
        }
    });
}

/**
 * Method to show and hide condition for add to cart at common place
 * @param {Object} $productAttributes - product details
 */
function addTOCartShowHide($productAttributes) {
    $productAttributes.find(outOfStockMessageClasses).addClass('d-none');
    $productAttributes.find(dynamicProductAvailabilityClass).removeClass('d-none');
    $productAttributes.find(promotionsClass).removeClass('d-none');
    $productAttributes.find(nonSellableMessageClasses).addClass('d-none');
    showProductAvailabilityElements();
    $(dynamicAttrClass).removeClass('d-none');
}

/**
 * Method to check if selected attribute value is OOS
 * @param {Object} productDetails - product details
 * @return {boolean} - true or false
 */
function checkIfSelectedValueOOS(productDetails) {
    var returnVal = false;
    productDetails.variationAttributes.forEach(function (data) {
        data.values.forEach(function (value) {
            if (value.selected && value.fullyOOSInd) {
                returnVal = true;
            }
        });
    });
    return returnVal;
}

/**
 * Replace 'Add to cart' button with 'Notify me' button when product is OOS and
 * represents a BISN-enabled style that is not unorderable (ie. offline or non-existent)
 * @param {Object} product - product model
 */
function replaceAddToCartWithBISN(product) {
    const isBISNEnabled = window.sitePrefs.bisnEnabled;
    const isBISNEligibleProduct = !product.available && !product.hasSelectedUnorderableVariant;
    const isBISNEnabledStyle = product.bisnEnabledStyle;
    const isBOPISFulfillment = $(bopisRadioButton).is(':checked');
    const isQuickView = $(addToCartClass).closest(productQuickViewClass).length > 0;

    if (isBISNEnabled && isBISNEligibleProduct && isBISNEnabledStyle && !isBOPISFulfillment && !isQuickView) {
        // this 'notify me' button differs from the fully OOS/non-sellable 'notify me' button
        $(bisnContainerClass).removeClass('d-none');
        $(addToCartClass).addClass('d-none');
    }
}

/**
 * Method to update PDP button when productVariation API is called from hashURL
 * @param {Object} productDetails - product details
 */
function updateButtonOnLoadingAttributeFromUrl(productDetails) {
    var fullyOutOfStock = false;
    var nonSellable = false;
    var isForcedSoldOut = false;
    const $productAttributes = $(productAttributesID);
    productDetails.variationAttributes.forEach(function (data) {
        data.values.forEach(function (value) {
            if (value.selected) {
                if (value.isNonSellable) {
                    nonSellable = true;
                } else if (value.fullyOOSInd) {
                    fullyOutOfStock = true;
                }
                if (value.isForcedSoldOut) {
                    isForcedSoldOut = true;
                }
            }
        });
    });

    // hide BISN modal trigger button
    $(bisnContainerClass).addClass('d-none');

    if (fullyOutOfStock) {
        $(dynamicAttrClass).addClass('d-none');
        $productAttributes.find(outOfStockMessageClasses).removeClass('d-none');
        $productAttributes.find(nonSellableMessageClasses).addClass('d-none');
        $productAttributes.find(dynamicProductAvailabilityClass).addClass('d-none');
        $productAttributes.find(promotionsClass).addClass('d-none');
        hideProductAvailabilityElements();
        updateNotifyMeButtonAttributes(productDetails);
        $(notifyCartClass).attr(DATA_CONTAINER_TYPE, 'out-of-stock-notify');
    } else if (nonSellable) {
        $(dynamicAttrClass).addClass('d-none');
        $productAttributes.find(outOfStockMessageClasses).addClass('d-none');
        $productAttributes.find(nonSellableMessageClasses).removeClass('d-none');
        $productAttributes.find(dynamicProductAvailabilityClass).addClass('d-none');
        $productAttributes.find(promotionsClass).addClass('d-none');
        hideProductAvailabilityElements();
        updateNotifyMeButtonAttributes(productDetails);
        if (productDetails.sellableFrom) {
            var todayDate = new Date();
            var tempCompareSellableDate = new Date(productDetails.sellableFrom);
            if (tempCompareSellableDate <= todayDate) {
                if (!checkIfSelectedValueOOS(productDetails)) {
                    addTOCartShowHide($productAttributes);
                    replaceAddToCartWithBISN(productDetails);
                } else {
                    $productAttributes.find(nonSellableMessageClasses).addClass('d-none');
                    $productAttributes.find(outOfStockMessageClasses).removeClass('d-none');
                }
                $(notifyCartClass).attr(DATA_CONTAINER_TYPE, 'out-of-stock-notify');
            } else {
                updateNonSellableMessage(productDetails.sellableFromFormattedDate, productDetails.sellableFromFormattedTime);
                $(notifyCartClass).attr(DATA_CONTAINER_TYPE, 'not-available-yet');
            }
        } else if (!checkIfSelectedValueOOS(productDetails)) {
            addTOCartShowHide($productAttributes);
            replaceAddToCartWithBISN(productDetails);
        }
    } else {
        addTOCartShowHide($productAttributes);
        replaceAddToCartWithBISN(productDetails);
    }

    if (isForcedSoldOut) {
        $(addToCartClass).attr('disabled', true);
    }

    $('#bisn-modal-trigger').data('isbisnenabledstyle', productDetails.bisnEnabledStyle);
}

/**
 * Function for filter recommendations on PDP
 * @param {*} element current size element
 */
function filterEinsteinRecommendationOnPDP(element) {
    var $currentElement = $(element);
    if ($currentElement.data('attr') === 'size-value' && $currentElement.hasClass('selected')) {
        var $filterRecommendation = $('.filter-recommendations');
        if ($filterRecommendation && $filterRecommendation.length > 0) {
            var isFootwear = $filterRecommendation.data('footwear');
            var gender = $filterRecommendation.data('gender');
            var size = $currentElement.data('attrvalue');
            if (isFootwear && size && gender) {
                var params = 'size=' + size + '&gender=' + gender;
                $(document).trigger('filterEinsteinRecommendations', params);
            }
        }
    }
}

/**
 * Method to trigger filter recommendations script
 * @param {*} element current size element
 */
function filterRecommendations(element) {
    if ((window.sitePrefs.enableFilterRecommendations === true) && element) {
        filterEinsteinRecommendationOnPDP(element);
    }
}

/**
 * updates the product view when a product attribute is selected or deselected or when
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {jQuery} $productContainer - DOM element for current product
 * @param {jQuery} currentElement - current clicked element
 */
function attributeSelect(selectedValueUrl, $productContainer, currentElement) {
    const $bopisRadioButton = $(bopisRadioButton);
    const isBOPISFulfillment = $bopisRadioButton.is(':checked');
    const storeId = $bopisRadioButton.data('store-id');
    let url = selectedValueUrl;

    if (selectedValueUrl && isBOPISFulfillment && storeId) {
        // add store ID as query param if set
        url = `${selectedValueUrl}&storeId=${encodeURIComponent(storeId)}`;
    }

    if (url) {
        $('body').trigger('product:beforeAttributeSelect',
            { url: url, container: $productContainer });
        // Initiating an AJAX call on a protected Shape end point is slow.
        // Prevent script from blocking UI updates via minute timeout.
        var callback = function () {
            $.ajax({
                url: url,
                method: 'GET',
                success: function (data) {
                    $('.product__id').html(data.product.id);
                    handleVariantResponse(data, $productContainer);
                    updateVolumental(data.product, $productContainer);
                    updateOptions(data.product.optionsHtml, $productContainer);
                    updateQuantities(data.product.quantities, $productContainer);
                    updateStickyImage(data.product.images, $productContainer);
                    updateButtonOnLoadingAttributeFromUrl(data.product);
                    $('body').trigger('product:afterAttributeSelect',
                        { data: data, container: $productContainer });
                    $productContainer.trigger('product.variantselectionchange', data);
                    if (window.sitePrefs.energyLaunchEnabled === true) {
                        var energyLaunch = require('energyLaunch/energyLaunch');

                        if (energyLaunch) {
                            energyLaunch.handleButtonRenderingOnEnergyLaunchPDP();
                        }
                    }
                    $.spinner().stop();
                    $(document).trigger('product:initialattrselect');
                    Bopis.update(data.pickUpInStore, data.product, $productContainer, data.storeInventoryMessageTemplate);
                    filterRecommendations(currentElement);
                },
                error: function () {
                    SpinnerOnModal(SPINNER_REQUIRED_MODALS, false);
                    $.spinner().stop();
                }
            });
        };
        setTimeout(callback, 5);
    } else {
        SpinnerOnModal(SPINNER_REQUIRED_MODALS, false);
    }
}

/**
 * Get query parameters
 * @param {string} url - url to play on
 * @return {Object} - Query Object to play with.
 */
function queryParameters(url) {
    var attributeUrl = new URL(url);
    var params = attributeUrl.search.substring(1);
    return JSON.parse('{"' + decodeURI(params).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');
}

/**
* Update the URL of the basis of attribute selected.
* @param {string} el - representing the clicked object.
*
* @return {void} - The provided URL to use when adding a product to the cart
*/
function updateUrlOnAttributeSelectionFromParameters(el) {
    var url = $(el).attr('data-url');
    if (url !== 'undefined' && url !== undefined && url !== null && url !== 'null') {
        var queryObject = queryParameters(url);
        // Create the final string to append.
        var stringToAppend = $.param(queryObject);
        var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + window.location.search + '#' + stringToAppend;
        window.history.replaceState({ path: newurl }, '', newurl);
    }
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @return {string} - The provided URL to use when adding a product to the cart
 */
function getAddToCartUrl() {
    return $('.add-to-cart-url').val();
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.choice-of-bonus-product');
    var footer = $html.find('.modal-footer').children();

    return { body: body, footer: footer };
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @param {Object} data - data object used to fill in dynamic portions of the html
 */
function chooseBonusProducts(data) {
    $(modalBodyClass).spinner().start();

    if ($(chooseBonusProductModalID).length !== 0) {
        $(chooseBonusProductModalID).remove();
    }
    var bonusUrl;
    if (data.bonusChoiceRuleBased) {
        bonusUrl = data.showProductsUrlRuleBased;
    } else {
        bonusUrl = data.showProductsUrlListBased;
    }

    var htmlString = '<!-- Modal -->'
        + '<div class="modal fade" id="chooseBonusProductModal" tabindex="-1" role="dialog">'
        + '<span class="enter-message sr-only" ></span>'
        + '<div class="modal-dialog choose-bonus-product-dialog" '
        + 'data-total-qty="' + data.maxBonusItems + '"'
        + 'data-UUID="' + data.uuid + '"'
        + 'data-pliUUID="' + data.pliUUID + '"'
        + 'data-addToCartUrl="' + data.addToCartUrl + '"'
        + 'data-pageStart="0"'
        + 'data-pageSize="' + data.pageSize + '"'
        + 'data-moreURL="' + data.showProductsUrlRuleBased + '"'
        + 'data-bonusChoiceRuleBased="' + data.bonusChoiceRuleBased + '">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + '    <span class="">' + data.labels.selectprods + '</span>'
        + '    <button type="button" class="close pull-right" data-dismiss="modal">'
        + '        <span aria-hidden="true">&times;</span>'
        + '        <span class="sr-only"> </span>'
        + '    </button>'
        + '</div>'
        + '<div class="modal-body"></div>'
        + '<div class="modal-footer"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
    $(modalBodyClass).spinner().start();

    $.ajax({
        url: bonusUrl,
        method: 'GET',
        dataType: 'json',
        success: function (response) {
            var parsedHtml = parseHtml(response.renderedTemplate);
            $('#chooseBonusProductModal .modal-body').empty();
            $('#chooseBonusProductModal .enter-message').text(response.enterDialogMessage);
            $('#chooseBonusProductModal .modal-header .close .sr-only').text(response.closeButtonText);
            $('#chooseBonusProductModal .modal-body').html(parsedHtml.body);
            $('#chooseBonusProductModal .modal-footer').html(parsedHtml.footer);
            $(chooseBonusProductModalID).modal('show');
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * This method imposes conditions to show the Mini-Cart o addition of item on the basis of platforms: -
 * 1. When on mobile, the minicart persists on screen.
 * 2. When on desktop, the minicart hides after 3 second.
 */
function miniCartShowHandler() {
    var $miniCartPopOver = $('.minicart .popover');
    var $miniCartSheet = $(miniCartSheetClass);
    var $document = $(document);

    if ($(window).width() <= 1024) {
        if ($miniCartPopOver.length > 0) {
            $miniCartPopOver.spinner().stop();
            $miniCartPopOver.addClass('show');
            $('body').addClass('modal-open');
        }

        if ($miniCartSheet.length > 0) {
            $miniCartSheet[0].openSheet();
        }

        setTimeout(function () {
            $document.find('.minicart select.custom-select').prop('disabled', true);
        }, 3000);
    } else {
        var miniCartTimer = setTimeout(function () {
            if ($miniCartPopOver.length > 0) {
                $miniCartPopOver.spinner().stop();
                $miniCartPopOver.removeClass('show');
            }

            if ($miniCartSheet.length > 0) {
                $miniCartSheet[0].closeSheet();
            }
        }, 3000);

        var cancelMiniCartTimer = function () {
            if (miniCartTimer) {
                clearTimeout(miniCartTimer);
            }
        };

        if ($miniCartSheet.length > 0) {
            var $sheetShadowRootContainer = $($miniCartSheet[0].sheetContainer);
            $sheetShadowRootContainer.on('minicart:hovered', cancelMiniCartTimer);
        }

        $document.on('minicart:hovered', cancelMiniCartTimer);
    }
}

/**
 * Hides the remove button on all minicart item cards. Primarily meant to be used
 * for immediately after a product is added to the cart
 */
function hideMiniCartItemCardFunctions() {
    const miniCartItemCards = document.querySelectorAll('.minicart-item-card');

    if (miniCartItemCards.length > 0) {
        miniCartItemCards.forEach(function (card) {
            const removeButton = card.querySelector('.remove-item');

            removeButton.classList.add('d-none');
        });
    }
}

/**
 * Modifies the minicart header to display a success message & icon when an item is added to the cart
 * @param {string} headerString - The success message to display in the minicart header
 */
function modifyMiniCartHeaderOnAddToCart(headerString) {
    const miniCartPopover = document.querySelector('.minicart .popover');
    const miniCartSheet = document.querySelector(miniCartSheetClass);

    if (miniCartPopover) {
        const miniCartItemsContainer = miniCartPopover.querySelector('.minicart-items-container');

        if (miniCartItemsContainer) {
            const successMessageElement = document.createElement('div');

            successMessageElement.className = 'minicart-success-msg col-12 py-3';
            successMessageElement.innerHTML = `<span class="checkmark mr-3"></span> ${headerString}`;
            miniCartItemsContainer.prepend(successMessageElement);
        }
    }

    if (miniCartSheet) {
        const sheetHeaderSlot = miniCartSheet.shadowRoot.querySelector('slot[name="sheet-header-text"]');
        const sheetHeaderSlotElement = sheetHeaderSlot.assignedElements()[0];

        if (sheetHeaderSlotElement) {
            const checkmarkIcon = sheetHeaderSlotElement.querySelector('svg');
            const headerText = sheetHeaderSlotElement.querySelector('span');

            checkmarkIcon.classList.remove('d-none');
            headerText.textContent = headerString;
        }
    }
}

/**
 * Opens the Mini-Cart after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 */
function showMiniCartOnAdd(response) {
    var $minicart = $('.minicart');
    var miniCartUrl = $minicart.length ? $('.minicart').data('action-url') : '';
    var $popover = $minicart.find('.popover');
    var $sheet = $minicart.find(miniCartSheetClass);
    var count = parseInt($minicart.find('.minicart-quantity').text(), 10);

    if (count !== 0 && (($popover.length && !$popover.hasClass('show')) || ($sheet.length && !$sheet.hasClass('open')))) {
        $.spinner().start();
        $.ajax({
            url: miniCartUrl,
            method: 'GET',
            success: function (data) {
                $.spinner().stop();

                if ($popover.length) {
                    $popover.spinner().start();
                    $popover.addClass('show');
                    $popover.empty().append(data);
                }

                if ($sheet.length) {
                    $sheet[0].openSheet();
                    $sheet.find('.sheet-body').spinner().start();
                    $sheet.replaceWith(data);
                    $sheet = $minicart.find(miniCartSheetClass);
                    var $sheetShadowRootContainer = $($sheet[0].sheetContainer);
                    // add listener to prevent minicart automatically closing when hovered over after add to cart
                    // specifically targeting sheet content container to avoid triggering on hovering sheet backdrop
                    $sheetShadowRootContainer.on('mouseenter touchstart', function () {
                        $sheetShadowRootContainer.trigger('minicart:hovered');
                    });
                }

                utils.initalizePaypal();
                modifyMiniCartHeaderOnAddToCart(response.minicartSuccessMsg);
                hideMiniCartItemCardFunctions();
                $('body').trigger('minicart:updateProductRecommendator');
                miniCartShowHandler();
            },
            error: function () {
                // Hide spinner
                $.spinner().stop();
            }
        });
    }
}

/**
 * Combines base label with selected value
 * @param {string} base - The base label (e.g., "Color")
 * @param {string} value - The selected value (e.g., "Red")
 * @returns {string} Formatted attribute string
 */
function formatAttribute(base, value) {
    if (!value) return ' ';
    return base + ' ' + value;
}

/**
* Gets current product attributes from both data attributes and DOM selections
* @param {jQuery} $addedToCartSuccessMsgCont - jQuery element containing base attribute labels
* @returns {{
*   color: string,
*   size: string,
*   width: string
* }} Object containing formatted product attributes
*/
function getProductAttributes($addedToCartSuccessMsgCont) {
    const $productAttributes = $('#productAtributes');
    const baseColor = $addedToCartSuccessMsgCont.data('color');
    const baseSize = $addedToCartSuccessMsgCont.data('size');
    let baseWidth = $addedToCartSuccessMsgCont.data('width');
    const selectedColor = $productAttributes.find('[data-attr="style"] button.selected').data('variation-value') || '';
    const selectedSize = $productAttributes.find('[data-attr="size"] button.selected').data('variation-value') || '';
    let selectedWidth = $productAttributes
        .find('[data-attr="width"] button.selected span.width-value')
        .first()
        .text()
        .trim();
    if (!selectedWidth) {
        selectedWidth = $productAttributes.find('[data-attr="cup"] button.selected span.cup-value').first().text().trim() || '';
        baseWidth = $addedToCartSuccessMsgCont.data('cup');
    }
    return {
        color: formatAttribute(baseColor, selectedColor),
        size: formatAttribute(baseSize, selectedSize),
        width: formatAttribute(baseWidth, selectedWidth)
    };
}

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 */
function handlePostCartAdd(response) {
    $('.minicart').trigger('count:update', response);
    // show add to cart toast
    if (response.newBonusDiscountLineItem
        && Object.keys(response.newBonusDiscountLineItem).length !== 0) {
        chooseBonusProducts(response.newBonusDiscountLineItem);
    }

    showMiniCartOnAdd(response);

    var $productContainer = $(productDetailClass).eq(0);
    if (response.qtyLimit && response.qtyLimit.limit) {
        $productContainer.find(limitedQtyMsgClass).removeClass('d-none');
        $productContainer.find(addToCartClass).prop('disabled', true);
    } else {
        $productContainer.find(limitedQtyMsgClass).addClass('d-none');
    }

    if ((response.preOrderData && response.preOrderData.hasPreOrder) || (response.backOrderData && response.backOrderData.hasBackOrder)) {
        $productContainer.find('button.add-to-cart').prop('disabled', true);
        $productContainer.find('.preorder-qty-msg').removeClass('d-none');
    }
    var $addedToCartSuccessMsgCont = $('.js-added-to-cart-success-msg');
    var productName = $addedToCartSuccessMsgCont.data('productname');
    var miniCartSuccessMsg = $addedToCartSuccessMsgCont.data('minicartsuccessmsg');
    var quantity = response.minicartCountOfItems;
    const objAttributeValue = getProductAttributes($addedToCartSuccessMsgCont);
    var msg = '<span class="sr-only">' + productName + ' ' + objAttributeValue.color + ' ' + objAttributeValue.size + ' ' + objAttributeValue.width + ' ' + miniCartSuccessMsg + ' ' + quantity + '</span>';
    $addedToCartSuccessMsgCont.html(msg);
}

/**
 * Retrieves the bundle product item ID's for the Controller to replace bundle master product
 * items with their selected variants
 *
 * @return {string[]} - List of selected bundle product item ID's
 */
function getChildProducts() {
    var childProducts = [];
    $('.bundle-item').each(function () {
        childProducts.push({
            pid: $(this).find(productIdClass).text(),
            quantity: parseInt($(this).find('label.quantity').data('quantity'), 10)
        });
    });

    return childProducts.length ? JSON.stringify(childProducts) : [];
}

/**
 * Retrieve product options
 *
 * @param {jQuery} $productContainer - DOM element for current product
 * @return {string} - Product options and their selected values
 */
function getOptions($productContainer) {
    var options = $productContainer
        .find('.product-option')
        .map(function () {
            var $elOption = $(this).find('.options-select');
            var urlValue = $elOption.val();
            var selectedValueId = $elOption.find('option[value="' + urlValue + '"]')
                .data('value-id');
            return {
                optionId: $(this).data('option-id'),
                selectedValueId: selectedValueId
            };
        }).toArray();

    return JSON.stringify(options);
}

/**
 * Makes a call to the server to report the event of adding an item to the cart
 *
 * @param {string | boolean} url - a string representing the end point to hit so that the event can be recorded, or false
 */
function miniCartReportingUrl(url) {
    if (url) {
        $.ajax({
            url: url,
            method: 'GET',
            success: function () {
                // reporting urls hit on the server
            },
            error: function () {
                // no reporting urls hit on the server
            }
        });
    }
}

/**
 *  hide desktop filters
*/
function hideFilters() {
    $(document).on('click', '.filters-hideshow-btn span.hide-filters', function (e) {
        e.preventDefault();
        var $this = $(this);

        $this.closest('.container').find('.hide-show-filter').toggleClass('hidden');
        $this.closest('.container').find(pgpGridsClass).toggleClass('col-lg-9');
        $this.find('.filter-hide, .filter-show').toggleClass('active');

        if ($('.refinement-bar').is(':visible') === true) {
            $('.filter-tabs-js').removeClass('d-lg-block');
            $('.category-seo-text').removeClass('hidefilter');
            $(pgpGridsClass).addClass('pl-lg-7');
        } else {
            $('.filter-tabs-js').addClass('d-lg-block');
            $('.category-seo-text').addClass('hidefilter');
            $(pgpGridsClass).removeClass('pl-lg-7');
        }

        $('body').trigger('carousels:reinit');
    });
} hideFilters();

/**
 *Activate color swatches
 */
function thumTouchImg() {
    $('body').on('click touchstart focus', '.color-swatches button.sildes', function (e) {
        e.stopPropagation();
        var $this = $(this).find('img.swatch-circle');
        var $slideEl = $this.closest(BUTTON_SLIDES);
        var pidUrl = $slideEl.attr('href');
        var pid = $slideEl.attr('data-style');
        var $productTile = $this.closest(productTileClass);
        var fullColorName = $this.attr('data-full-color-name');
        var productTileImageName = $productTile.find(imageContainerImg).attr('title').split(',')[0].trim();

        var standardUrl = $this.attr('data-src');
        var largeUrl = $this.attr('data-large-srcset');

        // Apply new dimensions using replaceAll only for mobile devices and .enlarged-mobile-image
        if (measures.isMobile() && $productTile.closest('.pgptiles').hasClass('enlarged-mobile-image')) {
            if (largeUrl) {
                largeUrl = largeUrl.replaceAll('wid=880', 'wid=920').replaceAll('hei=880', 'hei=920');
            }
            if (standardUrl) {
                standardUrl = standardUrl.replaceAll('wid=880', 'wid=920').replaceAll('hei=880', 'hei=920');
            }
        }

        var getUrl = largeUrl || standardUrl;

        var hoverStandardUrl = $this.attr('data-src-next');
        var hoverLargeUrl = $this.attr('data-large-srcset-next');
        var getHoverUrl = hoverLargeUrl || hoverStandardUrl;

        // New Badge (localized)
        var badgeName = $this.closest('.sildes').find('.badge-name-to-show').text();
        // Replace Image Source
        $productTile.find('.image-container picture.firstImage source, .image-container img').attr({ srcset: getUrl, src: getUrl });
        $productTile.find(imageContainerImg).attr({ alt: productTileImageName + ', ' + fullColorName + ', ' + pid, title: productTileImageName + ', ' + fullColorName + ', ' + pid });

        if (!measures.isMobile()) {
            // Replace Image source on hover element
            $productTile.find('.image-container picture.nextImage source, .image-container img').attr({ srcset: getHoverUrl, src: getHoverUrl });
        }

        // update selected outline
        $slideEl.closest('.color-swatches').find(BUTTON_SLIDES).removeClass('selected');
        $slideEl.addClass('selected');

        // update the link on the main image
        var anchorEl = $slideEl.parents(productTileClass).find(IMAGE_CONTAINER_ANCHOR);
        anchorEl.attr('href', pidUrl);

        // clear the current badge
        $productTile.find('.tile-badges').empty(); // eslint-disable-line sonarjs/no-duplicate-string

        var searchResultsContainer = $('.container.search-results.js-search-results');

        if (searchResultsContainer.hasClass('quick-view-icon-style')) {
            $productTile.find('.quick-view-icon').removeClass('unavailable');
        }

        // Show the badge name
        if (badgeName) {
            $productTile.find('.tile-badges').html('<span class="sub-badges pb-2 font-weight-bold d-inline-block">' + badgeName + '</span>');

            // Get non-localized badge name from DOM
            var productBadgeName = $this.closest('.sildes').find('.badge-name-to-show').data('badge-name');

            // Hide quick view icon for sold out and coming soon products
            if (productBadgeName && (productBadgeName.toLowerCase().trim() === 'sold out' || productBadgeName.toLowerCase().trim() === 'coming soon')) {
                if (searchResultsContainer.hasClass('quick-view-icon-style')) {
                    $productTile.find('.quick-view-icon').addClass('unavailable');
                }
            }
        }
    });
} thumTouchImg();

/**
 * Mouseover size swatches
 */
function mouseOverSizeSwatches() {
    $(document).on('mouseenter mouseleave', '.unisex-size', function (event) {
        if (isUnisexProduct()) {
            if (event.type === 'mouseenter') {
                toggleUnisexFitConversion($(this));
            } else {
                var $selectedSizeElement = $('button.unisex-size .selected');
                if ($selectedSizeElement && $selectedSizeElement.length > 0) {
                    toggleUnisexFitConversion($selectedSizeElement);
                } else {
                    displaySelectableVariant();
                }
            }
        }
    });
}
mouseOverSizeSwatches();

/**
 * wishlist on pgp
 */
function pgpWishlist() {
    var isUserLoggedIn = $('.is-wishlist-valid').length;
    $(document).on('click', '.wishListToggle .wishlist-inactive', function () {
        if (isUserLoggedIn) {
            $(this).toggleClass('active');
            $(this).closest('.wishListToggle').find('.wishlist-active').toggleClass('active');
        }
    });
    $(document).on('click', '.wishListToggle .wishlist-active', function () {
        if (isUserLoggedIn) {
            $(this).toggleClass('active');
            $(this).closest('.wishListToggle').find('.wishlist-inactive').toggleClass('active');
        }
    });
} pgpWishlist();

/**
 * mobile list view
 */
function listView() {
    $(document).on('click', '.grid-list .listview-inactive', function () {
        $('body').find('.product-grid .pgptiles').removeClass('col-6').addClass('col-12');
        $(this).removeClass('active');
        $(this).next().addClass('active');
        $(this).closest(gridListClass).find('.gridview-active').removeClass('active');
        $(this).closest(gridListClass).find('.gridview-inactive').addClass('active');
        localStorage.setItem('selectedViewStyle', 'listView');
    });
} listView();

/**
 * mobile grid view
 */
function gridView() {
    $(document).on('click', activeGridClasses, function () {
        $('body').find('.product-grid .pgptiles').removeClass('col-12').addClass('col-6');
        $(this).addClass('active');
        $(this).next().removeClass('active');
        $(this).closest(gridListClass).find('.list-view .listview-active').removeClass('active');
        $(this).closest(gridListClass).find('.list-view .listview-inactive').addClass('active');
        localStorage.setItem('selectedViewStyle', 'gridView');
    });
} gridView();

/**
 * select colorswatch
 * @param {Object} cs - color swatch instance
 * @param {Object} csImg - color swatch image instance
 * @param {Object} scope - this scope of colorswatch image
 */
function selectSwatch(cs, csImg, scope) {
    var productTile = scope.closest(productTileClass);

    var standardUrl = scope.attr('data-src');
    var largeUrl = scope.attr('data-large-src');
    var getUrl = largeUrl || standardUrl;

    var hoverStandardUrl = scope.attr('data-src-next');
    var hoverLargeUrl = scope.attr('data-large-srcset-next');
    var getHoverUrl = hoverLargeUrl || hoverStandardUrl;

    var srcSetUrls = getUrl + ' 1x, ' + getUrl.replace(/440/gi, '880') + ' 2x';
    var srcSetHoverUrls = getHoverUrl + ' 1x, ' + getHoverUrl.replace(/440/gi, '880') + ' 2x';

    var pidUrl = scope.closest(BUTTON_SLIDES).attr('href');

    productTile.find('.image-container picture source, .image-container img').attr({ src: getUrl, srcset: getUrl, 'data-srcset': srcSetUrls });

    if (!measures.isMobile()) {
        productTile.find('.image-container picture.nextImage source, .image-container img').attr({
            src: getHoverUrl,
            srcset: getHoverUrl,
            'data-srcset': srcSetHoverUrls
        });
    }

    productTile.find(IMAGE_CONTAINER_ANCHOR).attr('href', pidUrl);
    $(cs).find('button').removeClass('selected');
    $(csImg).closest('button').addClass('selected');

    // update quick view style data-style attribute
    productTile.each(function () {
        var colorway = $(csImg).closest('button').attr('data-style');
        productTile.find('.quick-view-icon').attr('data-style', colorway);
    });
}

/**
 * This function enhances the accessibility of a carousel by setting the proper ARIA attributes
 * @param {Element} $carouselSelector - The element that contains the carousel.
 */
function enhanceCarouselAccessibility($carouselSelector) {
    var slideCompare;
    $carouselSelector.on('afterChange', function (event, slick, currentSlide) {
        if (slideCompare !== currentSlide) {
            const $slideActive = $carouselSelector.find('.slick-slide.slick-active');
            const $currentSlideActive = $carouselSelector.find('.slick-slide.slick-current.slick-active');
            var horizontalCarouselDirection = $carouselSelector.attr('data-direction');
            var newSlideIn = horizontalCarouselDirection === 'left' ? $currentSlideActive.first() : $slideActive.last();
            newSlideIn.find('button').focus();
            setTimeout(function () {
                if (horizontalCarouselDirection === 'left') {
                    $currentSlideActive.prevAll().each(function (_index, element) {
                        $(element).attr(ARIA_HIDDEN, 'true').find('button').attr('tabindex', -1);
                    });
                }
            });
        }
    });

    $carouselSelector.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        slideCompare = currentSlide;
        if (currentSlide !== nextSlide) {
            $carouselSelector.attr('data-direction', currentSlide < nextSlide ? 'left' : 'right');
        }
    });
}

/**
 * Initiates slick slider carousel on the PGP
 * for product tiles with more than 3 colorways
 * @param {string} colorOverride - optional color to set
 */
function initSlickSlider(colorOverride) {
    var colors = [];
    var pgptilesEl = $('.pgptiles');

    // check for slick
    if (typeof $.fn.slick !== 'undefined') {
        // update the swatches width class
        pgptilesEl.find('.product-tile .color-swatches .swatches.w-100').removeClass('w-100').addClass('mx-auto');
        pgptilesEl.find('.product-tile .color-swatches .swatches.mx-auto').css('overflow', 'visible');

        // initialize the slider
        let $notSlickEl = pgptilesEl.find('.product-tile .color-swatches .swatches.mx-auto .getproduct:not(.slick-initialized)');
        const swatchFirstEl = $notSlickEl.first();
        $notSlickEl.on('init', function () {
            enhanceCarouselAccessibility($(this));
        });
        $notSlickEl.slick({
            infinite: false,
            speed: 300,
            slidesToShow: 6,
            slidesToScroll: 6,
            variableWidth: true,
            respondTo: 'window',
            responsive: [
                {
                    breakpoint: 1441,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 5
                    }
                },
                {
                    breakpoint: 1273,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4
                    }
                },
                {
                    breakpoint: 1101,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 6,
                        slidesToScroll: 6
                    }
                },
                {
                    breakpoint: 544,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 5
                    }
                },
                {
                    breakpoint: 451,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                }
            ],
            prevArrow: `<div class="prev"><button type="button" aria-label="${swatchFirstEl.data('previous-swatch')}"></button></div>`,
            nextArrow: `<div class="next"><button type="button" aria-label="${swatchFirstEl.data('next-swatch')}"></button></div>`,
            rtl: document.documentElement.getAttribute('dir') === 'rtl'
        });
    }

    if ($(selectedRefinementColorClasses).length >= 1 || colorOverride !== undefined) {
        $(selectedRefinementColorClasses).each(function () {
            var color = $(this).data('color').replace(/,/g, '').trim();
            if (color) {
                colors.push(color);
            }
        });

        if (colorOverride !== undefined) {
            colors.length = 0;
            colors.push(colorOverride);
        }

        $('.color-swatches').each(function (j, cs) {
            $(cs).find('img').each(function (k, csImg) {
                var productColors = $(csImg).data('colors');
                var defaultColors = $(csImg).data('defaultcolors');
                /* eslint-disable no-restricted-syntax */
                for (let c in colors) {
                    if (Object.prototype.hasOwnProperty.call(colors, c)) {
                        var filterColor = colors[c];
                        var foundPrimaryColor = false;

                        if (productColors.indexOf(filterColor) !== -1) {
                            if ((defaultColors && (productColors === defaultColors)) || (!defaultColors && productColors.indexOf(filterColor) === 0)) {
                                foundPrimaryColor = true;
                            }
                            selectSwatch(cs, csImg, $(this));
                        }

                        if (foundPrimaryColor === true) {
                            return false;
                        }
                    }
                }
                return true;
            });
        });
    }

    // adds an outline to the currently selected swatch
    pgptilesEl.find(productTileClass).each(function () {
        var $tileEl = $(this);
        if (!$tileEl.find('.color-swatches button.sildes.selected').length) {
            var colorway = $tileEl.find(imageContainerImg).attr('title').split(', ').pop();
            var $colorSwatch = $tileEl.find('.color-swatches button.sildes[title="' + colorway + '"]');
            $colorSwatch.addClass('selected');
            var colorSwatchUrl = $colorSwatch.attr('href');
            if (colorSwatchUrl) {
                $tileEl.find(IMAGE_CONTAINER_ANCHOR).attr('href', colorSwatchUrl);
            }
        }
    });
}

/**
 * Sets the carousel slider on pgp with or without search phrase
 * @return {boolean} return out of the function
 */
function setSlickSliderWithSearch() {
    var searchValue = ($('.search-field').attr('value') || '').toLowerCase();

    if (searchValue) {
        var foundSearchMatch = false;
        $('.refinements.desktop .refinement-color .color-attribute, .refinements.desktop .refinement-refinementcolor .color-attribute').each(function () {
            var displayValue = $(this).data('displayvalue');
            var color = $(this).data('color');
            if (searchValue.indexOf(displayValue.toLowerCase()) > -1) {
                initSlickSlider(color);
                foundSearchMatch = true;
                return false;
            }

            if (searchValue.indexOf(color.toLowerCase()) > -1) {
                initSlickSlider(color);
                foundSearchMatch = true;
                return false;
            }

            return true;
        });

        if (foundSearchMatch) {
            return false;
        }
    }

    initSlickSlider();
    return false;
}

setSlickSliderWithSearch();

// event for ajax calls
$('body').on('initSlickSlider', function () {
    if ($(selectedRefinementColorClasses).length >= 1) {
        initSlickSlider();
    } else {
        setSlickSliderWithSearch();
    }
});

// prevent clicks on mobile swatches
$('body').on('click touchstart', '.product-tile .color-swatches', function (e) {
    if (measures.isMobile()) {
        e.preventDefault();
    }
});

/**
 * On selecting color swatch, update the selected style to a data attribute on the product tile container
 */
$('body').on('touchstart focus', '.color-swatches button.sildes', function (e) {
    e.stopPropagation();
    var style = $(this).data('style');
    $(this).closest('.product').attr('data-selected-style', style);
});

// minimize file names
$('.pname').each(function () {
    var $nameLength = $(this).text().length;
    if ($nameLength > 38) {
        $(this).text($(this).text().substr(0, 38) + '…');
    }
});

/**
 * close mini cart in PDP
 */

$(document).on('click touchstart', '#mini-cart-close', function () {
    $(document).find('.popover.popover-bottom').removeClass('show');
    $('body').removeClass('modal-open');
});

/**
 * Moves focus to first input element when subscribe modal is opened.
 */
$(document).on('shown.bs.modal', '#subscribe-global-modal', function () {
    setTimeout(function () {
        var inputEl = $('#subscribe-global-modal').find('input[type!=hidden]');
        var inputVal = inputEl.val();
        inputEl.trigger('focus').val('').val(inputVal);
    }, 1000);
});

/**
 * Because there is always a selected style, utilize the Product-Variation URL
 * set on the selected style button to mimic an attribute selection when the
 * fulfillment method toggle changes
 */
function refreshVariationAttributesOnFulfillmentChange() {
    const selectedStyleButton = document.querySelector('button[data-attrid="style"].selected');

    if (selectedStyleButton) {
        // attributeSelect expects a jQuery object for $productContainer
        const $productContainer = $(selectedStyleButton).closest(productDetailClass);
        let url = selectedStyleButton.getAttribute('data-url');

        attributeSelect(url, $productContainer, selectedStyleButton);
    }
}

/**
 * Shipping method change event in PDP
 */
function shippingRadioChangeEvent() {
    $(document).on('change', '.js-radio-btn', function () {
        const $shippingRadioButton = $('#shippingMethodRadioButton');
        const $bopisRadioButton = $(bopisRadioButton);
        const storeSelected = $bopisRadioButton.data('store-id');

        if ($shippingRadioButton.is(':checked')) {
            $('#pdpShippingCollapseDetails').collapse('show');
            $('#shipping-method').addClass('selected');

            $('#pdpBopisCollapseDetails').collapse('hide');
            $(bopisMethodID).removeClass('selected');

            // variation attributes can be selected even when unavailable (ie. selectable = false)
            const isUnavailableVariationAttributeSelected = $(productAttributesID).find(selectedUnavailableAttributeClasses).length > 0;
            const isBISNEnabledStyle = $('#bisn-modal-trigger').data('isbisnenabledstyle');

            if (isUnavailableVariationAttributeSelected && isBISNEnabledStyle) {
                $(bisnContainerClass).removeClass('d-none');
                $(addToCartClass).addClass('d-none');
            }
        } else {
            if (!storeSelected) {
                // reverse fulfillment method selection
                $bopisRadioButton.prop('checked', false);
                $shippingRadioButton.prop('checked', true);

                // prompt user to select store
                var $storeFinderModal = $('#storeFinderModal');
                $storeFinderModal.data('prompt-store-selection', true);
                $storeFinderModal[0]?.openSheet($(bopisMethodID)[0]); // pass the input <label> so that focus is returned to it on modal/sheet close
                setTimeout(function () {
                    $('#store-postal-code').trigger('focus');
                }, 300);

                return;
            }

            $('#pdpShippingCollapseDetails').collapse('hide');
            $('#shipping-method').removeClass('selected');

            $('#pdpBopisCollapseDetails').collapse('show');
            $(bopisMethodID).addClass('selected');

            // hide BISN 'notify me' button if BOPIS is selected
            $(bisnContainerClass).addClass('d-none');
            $(addToCartClass).removeClass('d-none');
        }

        pdpInstoreInventory.showPickupStoreRadio(true);
        refreshVariationAttributesOnFulfillmentChange();
    });
}

module.exports = {
    attributeSelect: attributeSelect,
    thumTouchImg: thumTouchImg,
    pgpWishlist: pgpWishlist,
    listView: listView,
    gridView: gridView,
    refreshVariationAttributesOnFulfillmentChange: refreshVariationAttributesOnFulfillmentChange,
    removeListView: function () {
        $(window).resize(gridView);
    },

    methods: {
        editBonusProducts: function (data) {
            chooseBonusProducts(data);
        }
    },

    focusChooseBonusProductModal: function () {
        $('body').on('shown.bs.modal', chooseBonusProductModalID, function () {
            $(chooseBonusProductModalID).siblings().attr(ARIA_HIDDEN, 'true');
            $('#chooseBonusProductModal .close').focus();
        });
    },

    onClosingChooseBonusProductModal: function () {
        $('body').on('hidden.bs.modal', chooseBonusProductModalID, function () {
            $(chooseBonusProductModalID).siblings().attr(ARIA_HIDDEN, 'false');
        });
    },

    trapChooseBonusProductModalFocus: function () {
        $('body').on('keydown', chooseBonusProductModalID, function (e) {
            var focusParams = {
                event: e,
                containerSelector: chooseBonusProductModalID,
                firstElementSelector: '.close',
                lastElementSelector: '.add-bonus-products'
            };
            focusHelper.setTabNextFocus(focusParams);
        });
    },

    colorAttribute: function () {
        // The method colorAttribute() can be called more than once.
        // Calling off() before on() to prevent double event listeners and double HTTP calls.
        // The off() and on() selector strings need to be identical for this to work.
        var selector = '[data-attr="size-value"], [data-attr="style-value"], [data-attr="width-value"], [data-attr="cup-value"]';
        // eslint-disable-next-line sonarjs/cognitive-complexity
        $(document).off('click', selector).on('click', selector, function (e) {
            e.preventDefault();
            var $productContainer = $(this).closest('.set-item');
            if (!$productContainer.length) {
                $productContainer = $(this).closest(productDetailClass);
            }

            if (!$productContainer.hasClass('product-quickview') && this.classList.value.indexOf('selected') < 0) {
                updateUrlOnAttributeSelectionFromParameters(this);
            }

            var $notifyCart = $(notifyCartClass);
            // deselect action
            if (!$(this).hasClass('selected') || $(this).is('[data-attr="size-value"], [data-attr="width-value"], [data-attr="cup-value"]')) {
                $(this).closest('.attributes').find('.row').each(function () {
                    if (!$(this).hasClass('enable-bisn')) {
                        $(this).removeClass('d-none');
                    }
                });
                $(this).parent('div').find('button').removeClass('selected');
                $(this).parent('div').find('span').removeClass('selected');

                $(ADD_TO_CART_SELECTOR, $productContainer).attr('disabled', '');
                $('.out-of-stock-message').addClass('d-none');
                $(nonSellableMessageClass).addClass('d-none');

                if ($notifyCart.length && !$notifyCart.hasClass('d-none')) {
                    $(dynamicAttrClass).addClass('d-none');
                    $(nonSellableMessageClass).removeClass('d-none');
                    $(addToWishlistClass).addClass('d-none');
                }

                SpinnerOnModal(SPINNER_REQUIRED_MODALS, true);
                $('.availability-msg').hide();
                if ($(this).data('attrid') === 'size' && isUnisexProduct()) {
                    toggleUnisexFitConversion($(this));
                    e.stopPropagation();
                }
                if ($(this).attr('data-url') !== undefined) {
                    attributeSelect($(this).attr('data-url'), $productContainer, this);
                } else {
                    $('.update-cart-product-global').prop('disabled', true);
                    SpinnerOnModal(SPINNER_REQUIRED_MODALS, false);
                }
            }
        });
    },

    selectAttribute: function () {
        $(document).off('change', 'select[class*="select-"], .options-select').on('change', 'select[class*="select-"], .options-select', function (e) {
            e.preventDefault();

            var $productContainer = $(this).closest('.set-item');
            if (!$productContainer.length) {
                $productContainer = $(this).closest(productDetailClass);
            }
            attributeSelect(e.currentTarget.value, $productContainer);
        });
    },

    availability: function () {
        $(document).on('change', quantitySelectClass, function (e) {
            e.preventDefault();

            var $productContainer = $(this).closest(productDetailClass);
            if (!$productContainer.length) {
                $productContainer = $(this).closest(modalContentClass).find(productQuickViewClass);
            }

            if ($('.bundle-items', $productContainer).length === 0) {
                attributeSelect($(e.currentTarget).find('option:selected').data('url'),
                    $productContainer);
            }
        });
    },

    addToCart: function () {
        $(document).off('click', 'button.add-to-cart, button.add-to-cart-global').on('click', 'button.add-to-cart, button.add-to-cart-global', function () {
            var addToCartUrl;
            var pid;
            var pidsObj;
            var setPids;

            var isSticky = $(this.parentElement).hasClass('sticky-content');
            var productWrapper = $(this).closest('div.nb-modal__panel');
            if (!productWrapper.length) {
                productWrapper = $(this).closest('.product-wrapper');
            }

            $('.attribute', productWrapper).each(function () {
                var $this = $(this);
                var lenVal = $this.find('.selected').length;
                if (lenVal < 1) {
                    $this.addClass('error');
                } else {
                    $this.removeClass('error');
                }
            });

            if ($('.attribute.error', productWrapper).not('.attribute.quantity').length) {
                var element = $('.attribute.error', productWrapper).eq(0).parent();
                var errorElementOffset = element && element.length ? element.offset().top : 0;
                var headerHeight = $('.header-fixed').outerHeight();
                var quickViewModal = $('.product-quickview-modal');
                if (quickViewModal.length && quickViewModal.is(':visible')) {
                    $(quickViewModal).animate({
                        scrollTop: 0
                    }, 500);
                } else {
                    $('html, body').animate({
                        scrollTop: errorElementOffset - headerHeight
                    }, 500);
                }
                return;
            }

            $('body').trigger('product:beforeAddToCart', this);

            if ($('.set-items').length && $(this).hasClass('add-to-cart-global')) {
                setPids = [];

                $(productDetailClass).each(function () {
                    if (!$(this).hasClass('product-set-detail')) {
                        setPids.push({
                            pid: $(this).find(productIdClass).text(),
                            qty: $(this).find(quantitySelectClass).val(),
                            options: getOptions($(this))
                        });
                    }
                });
                pidsObj = JSON.stringify(setPids);
            }

            pid = getPidValue($(this));

            var $productContainer = $(this).closest(productDetailClass);
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.quick-view-dialog').find(productDetailClass);
            }

            addToCartUrl = getAddToCartUrl();

            var form = {
                pid: pid,
                pidsObj: pidsObj,
                childProducts: getChildProducts(),
                quantity: getQuantitySelected($(this)),
                estimatedDelivery: $('.delivery-estimate-message').text()
            };

            var csrfName = $(csrfClass).attr('name');
            var csrfValue = $(csrfClass).val();
            form[csrfName] = csrfValue;

            if (!$('.bundle-item').length) {
                form.options = getOptions($productContainer);
            }
            $('.js-added-to-cart-success-msg span').remove();
            $(this).trigger('updateAddToCartFormData', form);
            if (addToCartUrl) {
                setTimeout(function () {
                    $.ajax({
                        url: addToCartUrl,
                        method: 'POST',
                        data: form,
                        success: function (data) {
                            utils.checkForSessionLogout(data);
                            if (isSticky) {
                                $('html, body').animate({ scrollTop: 0 }, 700);
                            }
                            $('body').trigger('product:afterAddToCart', data);
                            handlePostCartAdd(data);
                            miniCartReportingUrl(data.reportingURL);
                        },
                        error: function (err) {
                            if (err && err.responseJSON && err.responseJSON.redirectUrl) {
                                window.location.href = err.responseJSON.redirectUrl;
                            } else {
                                $.spinner().stop();
                            }
                        }
                    });
                }, 2);
            }
        });
    },
    selectBonusProduct: function () {
        $(document).on('click', '.select-bonus-product', function () {
            var $choiceOfBonusProduct = $(this).parents('.choice-of-bonus-product');
            var pid = $(this).data('pid');
            var maxPids = $(chooseBonusProductDialogClass).data('total-qty');
            var submittedQty = parseInt($choiceOfBonusProduct.find('.bonus-quantity-select').val(), 10);
            var totalQty = 0;
            $.each($('#chooseBonusProductModal .selected-bonus-products .selected-pid'), function () {
                totalQty += $(this).data('qty');
            });
            totalQty += submittedQty;
            var optionID = $choiceOfBonusProduct.find('.product-option').data('option-id');
            var valueId = $choiceOfBonusProduct.find('.options-select option:selected').data('valueId');
            if (totalQty <= maxPids) {
                var selectedBonusProductHtml = ''
                + '<div class="selected-pid row" '
                + 'data-pid="' + pid + '"'
                + 'data-qty="' + submittedQty + '"'
                + 'data-optionID="' + (optionID || '') + '"'
                + 'data-option-selected-value="' + (valueId || '') + '"'
                + '>'
                + '<div class="col-sm-11 col-9 bonus-product-name" >'
                + $choiceOfBonusProduct.find('.product-name').html()
                + '</div>'
                + '<div class="col-1"><i class="fa fa-times" aria-hidden="true"></i></div>'
                + '</div>';
                $('#chooseBonusProductModal .selected-bonus-products').append(selectedBonusProductHtml);
                $(preCartProductsClass).html(totalQty);
                $(selectedBonusSummaryClasses).removeClass(ALERT_DANGER);
            } else {
                $(selectedBonusSummaryClasses).addClass(ALERT_DANGER);
            }
        });
    },
    removeBonusProduct: function () {
        $(document).on('click', '.selected-pid', function () {
            $(this).remove();
            var $selected = $('#chooseBonusProductModal .selected-bonus-products .selected-pid');
            var count = 0;
            if ($selected.length) {
                $selected.each(function () {
                    count += parseInt($(this).data('qty'), 10);
                });
            }

            $(preCartProductsClass).html(count);
            $(selectedBonusSummaryClasses).removeClass(ALERT_DANGER);
        });
    },
    enableBonusProductSelection: function () {
        $('body').on('bonusproduct:updateSelectButton', function (e, response) {
            $('button.select-bonus-product', response.$productContainer).attr('disabled',
                (!response.product.readyToOrder || !response.product.available));
            var pid = response.product.id;
            $('button.select-bonus-product', response.$productContainer).data('pid', pid);
        });
    },
    showMoreBonusProducts: function () {
        $(document).on('click', '.show-more-bonus-products', function () {
            var url = $(this).data('url');
            $(modalContentClass).spinner().start();
            $.ajax({
                url: url,
                method: 'GET',
                success: function (html) {
                    var parsedHtml = parseHtml(html);
                    $(modalBodyClass).append(parsedHtml.body);
                    $('.show-more-bonus-products:first').remove();
                    $(modalContentClass).spinner().stop();
                },
                error: function () {
                    $(modalContentClass).spinner().stop();
                }
            });
        });
    },
    addBonusProductsToCart: function () {
        $(document).on('click', '.add-bonus-products', function () {
            var $readyToOrderBonusProducts = $('.choose-bonus-product-dialog .selected-pid');
            var queryString = '?pids=';
            var url = $(chooseBonusProductDialogClass).data('addtocarturl');
            var pidsObject = {
                bonusProducts: []
            };

            $.each($readyToOrderBonusProducts, function () {
                var qtyOption = parseInt($(this).data('qty'), 10);

                var option = null;
                if (qtyOption > 0) {
                    if ($(this).data('optionid') && $(this).data('option-selected-value')) {
                        option = {};
                        option.optionId = $(this).data('optionid');
                        option.productId = $(this).data('pid');
                        option.selectedValueId = $(this).data('option-selected-value');
                    }
                    pidsObject.bonusProducts.push({
                        pid: $(this).data('pid'),
                        qty: qtyOption,
                        options: [option]
                    });
                    pidsObject.totalQty = parseInt($(preCartProductsClass).html(), 10);
                }
            });
            queryString += JSON.stringify(pidsObject);
            queryString = queryString + '&uuid=' + $(chooseBonusProductDialogClass).data('uuid');
            queryString = queryString + '&pliuuid=' + $(chooseBonusProductDialogClass).data('pliuuid');
            $.spinner().start();
            $.ajax({
                url: url + queryString,
                method: 'POST',
                success: function (data) {
                    $.spinner().stop();
                    if (data.error) {
                        $(chooseBonusProductModalID).modal('hide');
                        if ($(addToCartMessagesClass).length === 0) {
                            $('body').append('<div class="add-to-cart-messages"></div>');
                        }
                        $(addToCartMessagesClass).append(
                            '<div class="alert alert-danger add-to-basket-alert text-center"'
                            + ' role="alert">'
                            + data.errorMessage + '</div>'
                        );
                        setTimeout(function () {
                            $('.add-to-basket-alert').remove();
                        }, 3000);
                    } else {
                        $('.configure-bonus-product-attributes').html(data);
                        $('.bonus-products-step2').removeClass('hidden-xl-down');
                        $(chooseBonusProductModalID).modal('hide');

                        if ($(addToCartMessagesClass).length === 0) {
                            $('body').append('<div class="add-to-cart-messages"></div>');
                        }
                        $('.minicart-quantity').html(data.totalQty);
                        $(addToCartMessagesClass).append(
                            '<div class="alert alert-success add-to-basket-alert text-center"'
                            + ' role="alert">'
                            + data.msgSuccess + '</div>'
                        );
                        setTimeout(function () {
                            $('.add-to-basket-alert').remove();
                            if ($('.cart-page').length) {
                                // location.reload();
                            }
                        }, 1500);
                    }
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },
    initLocally: function (container) {
        var robisWrap = container.find('.robis-wrap');
        var robisButton = robisWrap.find('.robis-button');
        var robisAction = robisButton.find('.robis-button-action');
        var productMarkup = robisButton.closest(productDetailClass);
        var uniq = -1;

        $('.robis-wrap span.upc-available, .robis-wrap .icon-upc-available').hide();

        // This is a callback when data from Locally is returned
        window.addEventListener('LOCALLY_data_update', function (event) {
            if (event.detail.id !== uniq.toString()) {
                return;
            }
            if (event.detail.n_items_stocking_upc > 0) { // this product is in stock locally
                robisAction.removeClass('disabled').removeClass('unavailable');
                robisAction.removeClass(UPC_UNAVAILABLE).addClass(UPC_AVAILABLE);
                $('span.upc-available, .robis-wrap .icon-upc-available').show();
                $('.robis-button-action .icon-locator').hide();
            } else {
                robisAction.addClass('disabled');
                robisAction.removeClass(UPC_AVAILABLE).addClass(UPC_UNAVAILABLE);
                $('span.upc-available, .robis-wrap .icon-upc-available').hide();
                $('.robis-button-action .icon-locator').show();
            }
        }, false);
        // This triggers the locally modal; just catches the pretty robis button to fire the hidden Locally button
        robisAction.on('click', function () {
            if (!robisAction.hasClass('disabled')) {
                robisWrap.find('#lcly-button-' + uniq).find('.lcly-primary-trigger').click();
            }
        }); // trigger the locally modal

        // Gets a unique index for the Locally widget instance, zero based (can't use underscorejs)
        function getIndex() { // eslint-disable-line require-jsdoc
            if (window._locallyindexer >= 0) { // eslint-disable-line no-underscore-dangle
                window._locallyindexer += 1; // eslint-disable-line no-underscore-dangle
            } else {
                window._locallyindexer = 0; // eslint-disable-line no-underscore-dangle
            }
            return window._locallyindexer; // eslint-disable-line no-underscore-dangle
        }

        // triggered on initial variant selection change
        function initLocallyInternal(upc) { // eslint-disable-line require-jsdoc
            uniq = getIndex();

            // this configuration is stored in the locallyConfiguration site preference
            var config = robisWrap.data('locally-config');
            if (!config) {
                return;
            }

            var widgetwrap = $('<div>');
            widgetwrap.append($('<div>', { id: 'lcly-button-' + uniq, style: 'display: none;' }).html($('<a>', { id: 'lcly-link-' + uniq, href: 'https://brands.locally.com', target: '_blank' })));
            widgetwrap.append($('<script>', { id: 'lcly-script-' + uniq, async: 'async' }));
            widgetwrap.appendTo(robisWrap);

            config.upc = upc;
            var query = Object.keys(config).reduce(function (a, k) {
                a.push(encodeURIComponent(k) + '=' + encodeURIComponent(config[k]));
                return a;
            }, []).join('&');

            var endpoint = 'https://NewBalance.locally.com/stores/map.js?' + query;
            var scriptele = 'lcly-script-' + uniq;
            document.getElementById(scriptele).src = endpoint;
            robisButton.data('initialized', true);
            robisWrap.addClass('locally-' + uniq);
        }

        // called after every successive variant change
        function reloadLocally(upc) { // eslint-disable-line require-jsdoc
            var rel = 'lcly_reload_' + uniq;
            window[rel]({ upc: upc });
        }

        // Variant change handler
        productMarkup.on('product.variantselectionchange', function (e, data) {
            var prodType = data.product.productType;
            var pid = data.product.id;
            var quantity = data.product.selectedQuantity;

            if ((prodType === 'variant' || prodType === 'master') && quantity > 0) {
                if (!robisButton.data('initialized')) {
                    initLocallyInternal(pid);
                } else {
                    reloadLocally(pid);
                }
            } else {
                robisAction.removeClass(UPC_AVAILABLE).removeClass(UPC_UNAVAILABLE);
                robisAction.addClass('disabled');
            }

            var hasWidth = productMarkup.find('.attributes .variation-attribute.width-attribute').length > 0;
            if (hasWidth) {
                robisAction.addClass('has-width');
            }
        });
        var hasWidth = productMarkup.find('.attributes .variation-attribute.width-attribute').length > 0;
        if (hasWidth) {
            robisAction.addClass('has-width');
        }
        shippingRadioChangeEvent();
    },
    getPidValue: getPidValue,
    getQuantitySelected: getQuantitySelected,
    miniCartReportingUrl: miniCartReportingUrl,
    hideFilters: hideFilters,
    handlePostCartAdd: handlePostCartAdd,
    stickyProductDescription: stickyProductDescription,
    toggleAvailabilityMessage: toggleAvailabilityMessage,
    displayFitConversion: displayFitConversion
};

$(document).ready(function () {
    if ($(gridListClass).length) {
        determineDisplayStyle();
    }
});
